import { Box, Card, Grid, Typography } from "@mui/material";
import * as TapCardModal from "components/pages/game/decision-modals/TapCardModal";
import * as GameCard from "components/pages/game/GameCard";
import { CardType } from "models/CardType";
import React, { useState } from "react";

export interface Props {
  cards: CardType[];
  canTap: boolean;
}

export const Component: React.FC<Props> = ({ cards, canTap }) => {
  const [tappedCard, setTappedCard] = useState<CardType | null>(null);

  const renderCorp = () => {
    return cards
      .filter((card) => card.isCorporation)
      .map((card) => (
        <GameCard.Component
          key={card.name}
          name={card.name}
          isCorporation={card.isCorporation}
          isPrelude={card.cardType === "PRELUDE"}
          tooltip={card.tooltip}
          disabled={card.hasBeenTapped}
          hasBeenTapped={card.hasBeenTapped}
          counters={card.counters}
          counterType={card.counterType}
          tapOptions={card.tapOptions}
          onClick={() => {
            if (canTap && card.tapOptions.length > 0 && !card.hasBeenTapped) {
              setTappedCard(card);
            }
          }}
        />
      ));
  };

  const renderCards = (cardType: "ACTIVE" | "AUTOMATED") => {
    return cards
      .filter((card) => card.cardType === cardType)
      .filter((card) => !card.isCorporation)
      .map((card) => (
        <GameCard.Component
          key={card.name}
          name={card.name}
          isCorporation={card.isCorporation}
          isPrelude={card.cardType === "PRELUDE"}
          tooltip={card.tooltip}
          disabled={card.hasBeenTapped}
          hasBeenTapped={card.hasBeenTapped}
          counters={card.counters}
          counterType={card.counterType}
          tapOptions={card.tapOptions}
          onClick={() => {
            if (
              canTap &&
              card.tapOptions.length > 0 &&
              card.cardType === "ACTIVE" &&
              !card.hasBeenTapped
            ) {
              setTappedCard(card);
            }
          }}
        />
      ));
  };

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "row",
        borderRadius: 0,
      }}
    >
      <Box>
        <Typography variant="h5" sx={{ mt: 4 }}>
          Board
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sx={{ display: "flex", flexWrap: "wrap" }}>
            {renderCorp()}
          </Grid>
          <Grid item xs={12} sx={{ display: "flex", flexWrap: "wrap" }}>
            {renderCards("ACTIVE")}
          </Grid>
          <Grid item xs={12} sx={{ display: "flex", flexWrap: "wrap" }}>
            {renderCards("AUTOMATED")}
          </Grid>
        </Grid>
      </Box>
      {tappedCard !== null ? (
        <TapCardModal.Component
          card={tappedCard}
          isOpen={tappedCard !== null}
          onClose={() => setTappedCard(null)}
        />
      ) : null}
    </Card>
  );
};

Component.displayName = "PlayerBoard";
